import React from "react";
import PrintableAddForm from "@/components/PrintableAddForm";

const ROWS = [
  [
    { label: "Asset name / description", flex: 3 },
    { label: "Category (e.g. tool, computer, furniture)", flex: 2 },
  ],
  [
    { label: "Department", flex: 3 },
    { label: "Status (in use / spare / retired)", flex: 2 },
  ],
  [
    { label: "Supplier", flex: 3 },
    { label: "Purchase date", flex: 2 },
    { label: "Warranty end", flex: 2 },
  ],
  [
    { label: "Purchase price (approx)", flex: 2 },
    { label: "Location on floor", flex: 3 },
  ],
  [
    { label: "Assigned to (person / bench)", flex: 3 },
    { label: "Model / spec", flex: 2 },
  ],
];

const AssetAddPrint = () => (
  <PrintableAddForm
    pageTitle="Add asset"
    toolbarHint="Hand this out to staff walking the departments. Any asset found that isn't already in the app — one form per item, then give the page back to the manager."
    eyebrow="Podlab · Assets register"
    scope="Assets register"
    formTitle="Add-asset sheet"
    rows={ROWS}
    starField={{ label: "Serial number / asset tag" }}
    noteLabel="Notes · condition · accessories · anything odd"
    testid="add-asset-print-page"
  />
);

export default AssetAddPrint;
